import { React, useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import TOPBAR from "../../components/TopBar";
import SEARCHBAR from "../../components/SeachBar";
import MENUBAR from "../../components/Menu";
import FOOTER from "../../components/Footer";
import Itemcards from "../../components/Cards/itemscard";
import Pagination from 'react-bootstrap/Pagination';
import { ShimmerButton, ShimmerThumbnail, ShimmerCategoryItem } from "react-shimmer-effects";
import { RangeSlider } from 'rsuite';
import "rsuite/dist/rsuite.css";
import axios from 'axios';



export default function Products() {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const navigate = useNavigate();
    const { id } = useParams();
    const { state } = useLocation();
    const [vehicalYear, setVehicalYear] = useState(state?.year || "");
    const [vehicalMake, setVehicalMake] = useState(state?.make || "");
    const [vehicalModel, setVehicalModel] = useState(state?.model || "");
    const [vehicalVarient, setVehicalVarient] = useState(state?.variant || "");
    const [dataCategory, setDataCategory] = useState([]);
    const [isLoadingCategory, setIsLoadingCategory] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const [totalProducts, setTotalProducts] = useState(0);
    const [productsPerPage, setProductsPerPage] = useState(0);

    const [categoryName, setCategoryName] = useState('');

    const [dataBradnAndCategory, setDataBradnAndCategory] = useState([]);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const [dataYear, setDataYear] = useState([]);
    const [dataMake, setDataMake] = useState([]);
    const [dataModel, setDataModel] = useState([]);
    const [dataModelVarient, setDataVarient] = useState([]);


    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMake, setSelectedMake] = useState('');
    const [selectedModel, setSelectedModel] = useState('');
    const [selectedVariant, setSelectedVariant] = useState('');

    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMake, setIsLoadingMake] = useState(true);
    const [isLoadingModel, setIsLoadingModel] = useState(true);
    const [isLoadingVarient, setIsLoadingVarient] = useState(true);


    const [isLoaderMake, setIsLoaderMake] = useState(true);
    const [isLoaderModel, setIsLoaderModel] = useState(true);
    const [isLoaderVarient, setIsLoaderVarient] = useState(true);

    const [sortingValue, setSortingValue] = useState('');

    const MAX_PAGES_DISPLAY = 10;

    const [selectedBrands, setSelectedBrands] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);

    const [firstValue, setFirstValue] = useState(0);
    const [secondValue, setSecondValue] = useState(5000);





    useEffect(() => {
        fetchProductData();
    }, [currentPage, sortingValue, selectedCategories, selectedBrands, firstValue, secondValue]);

    useEffect(() => {
        fetchBrandAndCatData();
    }, []);

    useEffect(() => {
        fetchYearData();
    }, []);

    //fetch product items 
    const fetchProductData = async () => {
        window.scrollTo({ top: 400, behavior: 'smooth' });
        setIsLoadingCategory(true);
        const categoriesString = selectedCategories.join(',');
        const brandString = selectedBrands.join(',');
        const limit = 28; // Define the limit per page
        const offset = (currentPage - 1) * limit; // Calculate the offset based on the current page and limit
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/category/${id}?limit=${limit}&offset=${offset}&sorting=${sortingValue}&subcategories=${categoriesString}&brands=${brandString}&startingPrice=${firstValue}&endPrice=${secondValue}`,
            };
            axios.request(config)
                .then((response) => {
                    setDataCategory(response.data);
                    setIsLoadingCategory(false);
                    setTotalPages(response.data.totalPages);
                    setTotalProducts(response.data.count);
                    setProductsPerPage(response.data.data.length);
                    setCategoryName(response.data.data ? response.data.data[0].category_name : "");
                })
                .catch((error) => {
                    console.log(error);
                    navigate(`/error`);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoadingCategory(false);
            navigate(`/error`);
        }
    };


    //fetch brand  
    const fetchBrandAndCatData = async () => {

        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getSubCatBrandFromCat/${id}`,
            };
            axios.request(config)
                .then((response) => {
                    setDataBradnAndCategory(response.data);
                    setIsInitialLoad(false);
                })
                .catch((error) => {
                    console.log(error);
                    setIsInitialLoad(false);
                    navigate(`/error`);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsInitialLoad(false);
            navigate(`/error`);
        }
    };

    //fetch year


    const fetchYearData = async () => {
        setIsLoading(true);
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: `${mainUrl}/api/getYear`,
            };
            axios
                .request(config)
                .then((response) => {
                    setDataYear(response.data);
                    setIsLoading(false);
                    fetchMakeData(vehicalYear)
                })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                    navigate(`/error`);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsLoading(false);
            navigate(`/error`);
        }
    };

    const handleYearChange = (event) => {
        const selectedYear = event.target.value;


        if (selectedYear === "") {
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            setDataMake("")
            setDataModel("")
            setDataVarient("")

        } else {
            setSelectedYear(selectedYear);
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            // Fetch make data based on selected year
            fetchMakeData(selectedYear);
            setIsLoaderMake(false);

        }

    };

    const fetchMakeData = async (selectedYear) => {
        if (selectedYear) {
            setIsLoadingMake(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getMakeByYear/${selectedYear}`,
                };
                axios
                    .request(config)
                    .then((response) => {

                        setIsLoadingMake(false);
                        setDataMake(response.data);
                        setIsLoaderMake(true);
                        fetchModelData(vehicalYear, vehicalMake)
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingMake(false);
                        navigate(`/error`);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingMake(false);
                navigate(`/error`);
            }
        }
    };

    const handleMakeChange = (event) => {
        const selectedMake = event.target.value;
        setSelectedMake(selectedMake);

        // setDataMake([]);
        setDataModel([]);
        setSelectedModel('');
        setSelectedVariant('');
        // Fetch model data based on selected year and make
        setIsLoaderModel(false)
        fetchModelData(selectedYear, selectedMake);
    };

    const fetchModelData = async (selectedYear, selectedMake) => {
        if (selectedYear && selectedMake) {
            setIsLoadingModel(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getModelByMake/${selectedYear}/${selectedMake}`,
                };
                axios
                    .request(config)
                    .then((response) => {
                        console.log(JSON.stringify(response.data));
                        setIsLoadingModel(false);
                        setDataModel(response.data);
                        setIsLoaderModel(true)
                        fetchVariantData(vehicalYear, vehicalModel);
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingModel(false);
                        navigate(`/error`);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingModel(false);
                navigate(`/error`);
            }
        }
    };

    const handleModelChange = (event) => {
        const selectedModel = event.target.value;
        setSelectedModel(selectedModel);
        setSelectedVariant('');
        // Fetch variant data based on selected year, make, and model
        fetchVariantData(selectedYear, selectedModel);
        setIsLoaderVarient(false)
    };

    const fetchVariantData = async (selectedYear, selectedModel) => {
        if (selectedYear && selectedModel) {
            setIsLoadingVarient(true);
            try {
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: `${mainUrl}/api/getSubModelByModel/${selectedYear}/${selectedModel}`,
                };
                axios
                    .request(config)
                    .then((response) => {
                        console.log(JSON.stringify(response.data));
                        setIsLoadingVarient(false);
                        setDataVarient(response.data);
                        setIsLoaderVarient(true)
                    })
                    .catch((error) => {
                        console.log(error);
                        setIsLoadingVarient(false);
                        navigate(`/error`);
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoadingVarient(false);
                navigate(`/error`);
            }
        }
    };

    const handleVarientChange = (event) => {
        const selectedVarient = event.target.value;
        setSelectedVariant(selectedVarient);

    };
    const handleSorting = (event) => {
        const sortingValue = event.target.value;
        console.log(sortingValue);
        setSortingValue(sortingValue);
    };


    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 400, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const totalDisplayPages = Math.min(totalPages, MAX_PAGES_DISPLAY);
        const middlePage = Math.ceil(totalDisplayPages / 2);
        let startPage = 1;

        if (currentPage > middlePage) {
            startPage = currentPage - middlePage + 1;
        }

        const endPage = startPage + totalDisplayPages - 1;

        return Array.from({ length: totalDisplayPages }, (_, index) => startPage + index);
    };



    function handleRanges(value) {
        setFirstValue(value[0]);
        setSecondValue(value[1]);
    }



    const handleSubmit = (event) => {
        let state = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel,
            variant: selectedVariant,
        }
        navigate('/search-products', { state: state });
    };

    const handleBrandCheckboxChange = (event) => {
        window.scrollTo({ top: 400, behavior: 'smooth' });
        const brandId = event.target.value;
        if (selectedBrands.includes(brandId)) {
            setSelectedBrands(selectedBrands.filter((id) => id !== brandId));
        } else {
            setSelectedBrands([...selectedBrands, brandId]);
        }

        console.log('selectesetSelectedBrandsdBrands', selectedBrands)
    };

    const handleCategoryCheckboxChange = (event) => {
        window.scrollTo({ top: 400, behavior: 'smooth' });
        const categoryId = event.target.value;
        if (selectedCategories.includes(categoryId)) {
            setSelectedCategories(selectedCategories.filter((id) => id !== categoryId));
        } else {
            setSelectedCategories([...selectedCategories, categoryId]);
        }
        console.log('setSelectedCategories', selectedCategories)
    };
    return (
        <>
            <TOPBAR />
            <SEARCHBAR />
            <MENUBAR />
            <section>
                <div className="main-inner-banner">
                    <div className="parformane-bar">
                        <div className="container">
                            <ul className="p-0 m-0 listing-parmofamne">
                                <li><a href="/">Home /</a></li>
                                <li className="active-bread"><a href="#">{categoryName}</a></li>
                            </ul>
                        </div>
                    </div>
                    <h1 className="text-center txt-main-listing">{categoryName}</h1>
                </div>
            </section>

            <section>
                <div className="main-section-lsting">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="main-outer-filter">
                                    <div className="filter-crose" id="close-bar">
                                        <button className="abc">
                                            <img src="/images/x-mark.svg" alt="" />
                                        </button>
                                    </div>
                                    <div className="filters">
                                        <h3>Search by Vehicle</h3>
                                    </div>
                                    <div className="select-bars">
                                        <select className="selet-btns w-100" name="cars" id="cars" onChange={handleYearChange} value={vehicalYear}>
                                            <option value="">Year</option>
                                            {
                                                !isLoading && dataYear && dataYear.data
                                                    ? dataYear.data.map((item, index) => (
                                                        <option className="ymm-li" value={item.years} key={item.id}>
                                                            {item.years}
                                                        </option>
                                                    ))
                                                    : ""}

                                        </select>
                                        {/* {
                                            !isLoading
                                                ?

                                                ""
                                                : <Loader />
                                        } */}

                                        <select className="selet-btns w-100 mt-2" name="cars" id="cars" onChange={handleMakeChange} value={vehicalMake}>
                                            <option value="">Make</option>
                                            {
                                                !isLoadingMake && dataMake && dataMake.data
                                                    ? dataMake.data.map((item, index) => (
                                                        <option className="ymm-li" value={item.make_fitment_id} key={index}>
                                                            {item.make_fitment_value}
                                                        </option>
                                                    ))
                                                    : ""}
                                        </select>
                                        {/* {
                                            isLoaderMake
                                                ?
                                                ""
                                                : <LoaderMake />
                                        }

                                    </select> */}
                                        <select className="selet-btns w-100 mt-2" name="cars" id="cars" onChange={handleModelChange} value={vehicalModel}>
                                            <option value="volvo">Model</option>
                                            {
                                                !isLoadingModel && dataModel && dataModel.data
                                                    ? dataModel.data.map((item, index) => (
                                                        <option className="ymm-li" value={item.model_fitment_id} key={index}>
                                                            {item.model_fitment_value}
                                                        </option>
                                                    ))
                                                    : ""}

                                        </select>
                                        <select className="selet-btns w-100 mt-2" name="cars" id="cars" onChange={handleVarientChange} value={vehicalVarient}>
                                            <option value="">Variants</option>
                                            {
                                                !isLoadingVarient && dataModelVarient && dataModelVarient.data
                                                    ? dataModelVarient.data.map((item, index) => (
                                                        <option className="ymm-li" value={item.vcdb_submodel_id} key={index}>
                                                            {item.name}
                                                        </option>
                                                    ))
                                                    : ""}

                                        </select>

                                        {
                                            !selectedModel ?
                                                (<button className="serch-btn mt-1" disabled>

                                                    <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                            fill="white"></path>
                                                        <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                            fill="white"></path>
                                                        <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                            fill="white"></path>
                                                        <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                            fill="white"></path>
                                                        <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                            fill="white"></path>
                                                    </svg>
                                                    Search
                                                </button>)

                                                :

                                                <button className="serch-btn mt-1" onClick={handleSubmit} >

                                                    <svg width="32" height="23" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M3.92351 7.13048C3.52844 7.13048 3.20801 7.45067 3.20801 7.84598C3.20801 8.24128 3.52845 8.56148 3.92351 8.56148H7.10778C7.21609 8.07632 7.35485 7.59841 7.52281 7.13048H3.92351Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M5.3548 11.4239C5.3548 11.2342 5.27943 11.052 5.14516 10.918C5.01089 10.7837 4.82896 10.7084 4.63903 10.7084H1.06121C0.666136 10.7084 0.345703 11.0286 0.345703 11.4239C0.345703 11.8192 0.666149 12.1394 1.06121 12.1394H4.63903C4.82896 12.1394 5.01089 12.064 5.14516 11.9297C5.27943 11.7957 5.3548 11.6136 5.3548 11.4239Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M3.92351 14.2861C3.52844 14.2861 3.20801 14.6063 3.20801 15.0017C3.20801 15.397 3.52845 15.7172 3.92351 15.7172H7.53724C7.36904 15.2492 7.23052 14.7713 7.12221 14.2861H3.92351Z"
                                                            fill="white"></path>
                                                        <path d="M12.9824 13.9284C13.2689 14.7036 13.6904 15.4218 14.2275 16.05L15.4117 13.9284H12.9824Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M22.7293 10.3505C22.4725 10.3528 22.2342 10.2175 22.1049 9.99566C21.9754 9.77379 21.9749 9.49977 22.1031 9.27716L24.0672 5.76718L24.0675 5.76743C23.4975 5.32769 22.8658 4.9743 22.1927 4.71899L20.3072 8.0964V8.09665C20.1782 8.32002 19.9388 8.45653 19.681 8.45429C19.423 8.45653 19.1839 8.32002 19.0549 8.09665L17.1621 4.72621C16.489 4.98152 15.8574 5.33491 15.2873 5.77438L17.2552 9.27708C17.3837 9.4997 17.383 9.77372 17.2537 9.99558C17.1242 10.2175 16.8858 10.3527 16.629 10.3505H12.6078C12.4979 11.062 12.4979 11.7858 12.6078 12.4973H16.629C16.8858 12.4951 17.1242 12.6303 17.2537 12.8522C17.383 13.0741 17.3837 13.3481 17.2552 13.5707L15.2911 17.0807V17.0804C15.8604 17.5174 16.4908 17.8681 17.1621 18.1216L19.0511 14.7442H19.0513C19.1804 14.5209 19.4194 14.3841 19.6775 14.3863C19.9353 14.3841 20.1746 14.5209 20.3034 14.7442L22.1889 18.1216C22.862 17.8663 23.494 17.5129 24.064 17.0735L22.1031 13.5708C21.9749 13.3481 21.9754 13.0741 22.1049 12.8523C22.2342 12.6304 22.4725 12.4951 22.7293 12.4974H26.7509C26.8654 11.7863 26.8654 11.0616 26.7509 10.3505L22.7293 10.3505ZM19.6668 12.1395C19.3773 12.1395 19.1163 11.9653 19.0057 11.6977C18.8949 11.4304 18.956 11.1227 19.1607 10.9181C19.3653 10.7134 19.673 10.652 19.9406 10.7628C20.2079 10.8737 20.3823 11.1345 20.3823 11.424C20.3823 11.6136 20.3069 11.7958 20.1727 11.9299C20.0384 12.0641 19.8565 12.1395 19.6668 12.1395Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M18.5928 18.4939C19.3101 18.6047 20.04 18.6047 20.7573 18.4939L19.6839 16.5583L18.5928 18.4939Z"
                                                            fill="white"></path>
                                                        <path d="M14.2275 6.79761C13.6904 7.42577 13.2689 8.14402 12.9824 8.9192H15.4117L14.2275 6.79761Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M20.7602 4.35383C20.0429 4.24302 19.313 4.24302 18.5957 4.35383L19.6691 6.2895L20.7602 4.35383Z"
                                                            fill="white"></path>
                                                        <path d="M26.374 8.91941C26.0873 8.14423 25.6657 7.42599 25.1289 6.79782L23.959 8.91941H26.374Z"
                                                            fill="white"></path>
                                                        <path d="M25.129 16.0502C25.6658 15.422 26.0873 14.7037 26.3741 13.9286H23.959L25.129 16.0502Z"
                                                            fill="white"></path>
                                                        <path
                                                            d="M29.6843 11.4239C29.6843 11.0286 30.0047 10.7084 30.4001 10.7084H31.1156C30.9538 8.16876 29.9463 5.75667 28.2532 3.85684L27.7773 4.34001C27.4978 4.62052 27.0436 4.62127 26.7631 4.34175C26.4825 4.06224 26.4818 3.60804 26.7613 3.3275L27.248 2.83735C25.3405 1.15078 22.9234 0.151994 20.3824 0V0.690585C20.3824 1.0859 20.0619 1.40609 19.6669 1.40609C19.2715 1.40609 18.9511 1.08589 18.9511 0.690585V0C16.4105 0.161718 13.9972 1.16925 12.0964 2.86233L12.583 3.34524H12.5828C12.7535 3.46828 12.8616 3.65995 12.878 3.86959C12.8947 4.07922 12.8181 4.28562 12.6689 4.43386C12.5196 4.58211 12.3128 4.65698 12.1034 4.63901C11.8937 4.62079 11.7028 4.51148 11.581 4.34002L11.1016 3.8571V3.85685C9.40876 5.75681 8.40096 8.16891 8.23926 10.7084H8.93355C9.32862 10.7084 9.64905 11.0286 9.64905 11.4239C9.64905 11.8192 9.32861 12.1394 8.93355 12.1394H8.25721C8.41868 14.679 9.42646 17.0911 11.1195 18.9909L11.581 18.5078C11.8608 18.2273 12.3147 18.2265 12.5952 18.506C12.876 18.7856 12.8768 19.2397 12.5972 19.5203L12.1106 20.0104C14.0118 21.7035 16.4251 22.7113 18.966 22.8728V22.1573C18.966 21.7619 19.2862 21.4418 19.6815 21.4418C20.0765 21.4418 20.397 21.762 20.397 22.1573V22.8479C22.9363 22.6856 25.3484 21.6781 27.2485 19.9855L26.7618 19.5026C26.4823 19.2218 26.4831 18.7679 26.7636 18.4881C27.0441 18.2086 27.4983 18.2093 27.7778 18.4901L28.2538 18.991C29.9469 17.091 30.9544 14.6789 31.1161 12.1394H30.4006C30.0053 12.1394 29.6848 11.8192 29.6848 11.4239L29.6843 11.4239ZM28.0314 13.3523C27.6426 15.0479 26.7421 16.5827 25.4519 17.7495C24.4813 18.6265 23.3237 19.2713 22.0672 19.635C20.5241 20.0785 18.8874 20.0785 17.3446 19.635H17.3194C16.071 19.2706 14.9212 18.6285 13.9561 17.7568C13.3155 17.174 12.7654 16.4987 12.3247 15.7533C11.8895 15.0078 11.5698 14.2007 11.3766 13.3596C11.0856 12.0903 11.0856 10.7718 11.3766 9.50278C11.7654 7.80721 12.6661 6.27239 13.9561 5.10563C14.9067 4.2274 16.0428 3.57426 17.2799 3.19494H17.3051C18.8561 2.74871 20.5015 2.74871 22.0529 3.19494H22.0778C23.3262 3.55956 24.4759 4.20172 25.441 5.07343C26.0819 5.65593 26.6317 6.33129 27.0725 7.07695C27.5077 7.82216 27.8274 8.62928 28.0206 9.47058C28.3163 10.7391 28.3163 12.0589 28.0206 13.3274L28.0314 13.3523Z"
                                                            fill="white"></path>
                                                    </svg>
                                                    Search

                                                </button>


                                        }
                                    </div>
                                    <div className="price-filter">
                                        <h3 className="price-filter-text">
                                            {/* Price <i className="fa fa-minus"></i> */}Price
                                        </h3>
                                        <div className="">
                                            <RangeSlider
                                                min={0}
                                                step={1}
                                                max={5000}
                                                defaultValue={[0, 5000]}
                                                onChangeCommitted={handleRanges}

                                            />
                                            <br />
                                            Price between {firstValue} - {secondValue}.
                                        </div>
                                    </div>
                                    <div className="price-filter">
                                        <h3 className="price-filter-text" data-bs-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="false" aria-controls="collapseExample1">
                                            {/* Category <i className="fa fa-minus"></i> */}Category {dataBradnAndCategory.uniqueSubcategories ? "(" + dataBradnAndCategory.uniqueSubcategories.length + ")" : " "}
                                        </h3>
                                        <div className="collapse show" id="collapseExample1">
                                            <ul className="p-0 m-0 list-filter">
                                                {
                                                    !isInitialLoad && dataBradnAndCategory ?
                                                        dataBradnAndCategory.uniqueSubcategories.map((item, index) => (
                                                            <li key={index}>
                                                                <label className="label-filter">
                                                                    <input
                                                                        className="filter-box"
                                                                        type="checkbox"
                                                                        value={item.sub_category_id}
                                                                        checked={selectedCategories.includes(item.sub_category_id)}
                                                                        onChange={handleCategoryCheckboxChange}

                                                                    />
                                                                    {item.sub_category_name}
                                                                </label>
                                                            </li>
                                                        ))
                                                        : <ShimmerCategoryItem />

                                                }
                                            </ul>

                                        </div>
                                    </div>
                                    <div className="price-filter">
                                        <h3 className="price-filter-text" data-bs-toggle="collapse" href="#collapseExample2" role="button" aria-expanded="false" aria-controls="collapseExample2">
                                            {/* Brand <i className="fa fa-minus"></i> */}Brand {dataBradnAndCategory.uniqueBrands ? "(" + dataBradnAndCategory.uniqueBrands.length + ")" : " "}
                                        </h3>
                                        <div className="collapse show" id="collapseExample2">
                                            <ul className="p-0 m-0 list-filter">
                                                {
                                                    !isInitialLoad && dataBradnAndCategory ?
                                                        dataBradnAndCategory.uniqueBrands.map((item, index) => (
                                                            <li key={index}>
                                                                <label className="label-filter">
                                                                    <input className="filter-box"
                                                                        type="checkbox"
                                                                        value={item.brand_id}
                                                                        // checked={selectedBrands.includes(item.brand_id)}
                                                                        onChange={handleBrandCheckboxChange}
                                                                    />
                                                                    {item.brand_name}
                                                                </label>
                                                            </li>
                                                        ))
                                                        : <ShimmerCategoryItem />

                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9">
                                <div className="main-headin">
                                    <div className="Drivetrain">
                                        <h3>{categoryName}</h3>
                                        <p className="m-0">Showing {productsPerPage} of {parseInt(totalProducts).toLocaleString('en-US')} products</p>
                                        <select className="" name="sorting" id="sortingWithPrice" onChange={handleSorting}>

                                            <option disabled >Sort By Price</option>
                                            <option value="1">Low-High</option>
                                            <option value="2">High-Low</option>

                                        </select>

                                    </div>
                                    <div className="main-filter-resposive">
                                        <button className="mobile-filter-btn"> <svg className="me-1" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.25901 14.35L5.25888 14.35C5.24769 14.3502 5.23405 14.3476 5.21863 14.339L5.21836 14.3389C5.19936 14.3282 5.19074 14.318 5.18703 14.3124C5.17887 14.2972 5.176 14.2839 5.176 14.2707V7.91365C5.176 7.82275 5.1652 7.72056 5.13235 7.61486C5.09945 7.50839 5.04961 7.41561 4.99386 7.33726L0.724519 1.26892C0.724485 1.26887 0.724451 1.26882 0.724418 1.26877C0.676725 1.20083 0.65495 1.13291 0.650688 1.06991C0.64665 1.00345 0.660203 0.933143 0.696549 0.863781L0.696552 0.863774C0.732993 0.794228 0.783357 0.74264 0.84197 0.707465L0.841971 0.707466L0.843135 0.706765C0.902543 0.670943 0.973036 0.65 1.05357 0.65H12.9463C13.0271 0.65 13.0973 0.670932 13.1564 0.706609L13.1578 0.70745C13.2164 0.742594 13.2667 0.794096 13.3032 0.863535C13.3407 0.935416 13.3534 1.00516 13.3492 1.06874C13.345 1.13245 13.3232 1.20066 13.2755 1.26862C13.2755 1.26872 13.2754 1.26882 13.2753 1.26892L9.0045 7.33779L9.00402 7.33848C8.94618 7.42089 8.90098 7.51067 8.86985 7.6068L8.86979 7.60678L8.8672 7.61518C8.83481 7.71999 8.82355 7.82177 8.82355 7.91441V12.1555C8.82355 12.1724 8.81984 12.1838 8.81525 12.1923C8.81075 12.1999 8.8025 12.2101 8.78506 12.2207L8.34805 12.4857L8.34827 12.4864L5.3042 14.3361C5.30409 14.3362 5.30399 14.3362 5.30388 14.3363C5.28736 14.3462 5.27261 14.3497 5.25901 14.35ZM5.27154 14.9999C5.14389 15.0023 5.01635 14.9707 4.90099 14.9061L5.27154 14.9999Z" stroke="#E81C2E" stroke-width="1.3"></path>
                                        </svg>
                                            Filters</button>
                                    </div>
                                </div>

                                <div className='row'>
                                    {


                                        !isLoadingCategory && dataCategory ?
                                            dataCategory.data.map((itm, idx) => {
                                                return (<Itemcards data={itm} key={itm.item_id} />);
                                            })
                                            :
                                            Array.from({ length: 28 }).map((_, idx) => (
                                                <div className="col-lg-3 col-6" key={idx}>
                                                    <a href="#">
                                                    </a>
                                                    <div className="Drivetrain-cart"><a href="">
                                                        <div className="engle-imge-upper">
                                                            {/* <button className="hover-btn">View Details</button> */}
                                                            <ShimmerThumbnail height={163} rounded />
                                                        </div>
                                                    </a>
                                                        <div className="cart-body">
                                                            <a href="#">
                                                                <h6><ShimmerButton size="sm" /></h6>
                                                                <span className="m-0 description text-dark" ><ShimmerButton size="md" width="100%" /></span>


                                                            </a>
                                                            <div className="price-cart">
                                                                <a href="#">
                                                                    <div className="price">
                                                                        {/* {
                                                                        itm && itm.cost ?
                                                                            <h5 className="m-0">${itm.cost}</h5>
                                                                            :
                                                                            <h5 className="m-0">N.A</h5>
                                                                    } */}

                                                                    </div>
                                                                </a>
                                                                <div className="cart-btn">
                                                                    <a href="#">
                                                                    </a>
                                                                    <a href="#">

                                                                        {/* <img src={data.data.brand_logo} alt="" /> */}
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            ))

                                    }


                                </div>
                                <div className="d-flex mt-4 justify-content-center">
                                    <Pagination>
                                        <Pagination.First
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(1)}
                                        />
                                        <Pagination.Prev
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        />

                                        {/* Render page numbers */}
                                        {getPageNumbers().map((page) => (
                                            <Pagination.Item
                                                key={page}
                                                active={currentPage === page}
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page}
                                            </Pagination.Item>
                                        ))}

                                        <Pagination.Next
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        />
                                        <Pagination.Last
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(totalPages)}
                                        />
                                    </Pagination>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section >
            {/* <NEWSLETTER /> */}
            < FOOTER />
        </>

    )
}
